import * as angular from "angular";
import * as _ from "lodash";
import {SitesRequestsService} from "../modules/sites/services/sites-requests.service";
import {OrganizationsRequestsService} from "../modules/organizations/services/organizations-requests.factory";
import {NgxPermissionsService, NgxRolesService} from "ngx-permissions";
import {ILogService, IQService} from "angular";
import {SiteContextService} from "../modules/commons/services/site-context.service";

export class IAMPermissionsService {

  /* @ngInject */
  constructor(private organizationsRequestsService: OrganizationsRequestsService, private sitesRequestsService: SitesRequestsService,
              private PermPermissionStore, private PermRoleStore, private IamRequests, private permissionsService: NgxPermissionsService,
              private ngxRolesService: NgxRolesService, private siteContextService: SiteContextService, private $q: IQService, private $log: ILogService) {

  }

  setSuperPermissions() {
    this.clearCurrentPermissions();
    return this.IamRequests.getSuperRoles()
      .then((iamRoles) => {
        this.defineIamRoles(iamRoles, []);
        return iamRoles;
      });
  }

  setOrganizationPermissions(organizationId) {
    this.clearCurrentPermissions();
    return this.organizationsRequestsService.getOrganizationRoles(organizationId)
      .then((iamRoles) => {
        this.defineIamRoles(iamRoles, []);
        return iamRoles;
      });
  }

  setSitePermissionsOld(siteId, modules) {
    this.clearCurrentPermissions();
    return this.sitesRequestsService.getSiteRoles(siteId)
      .then((iamRoles) => {

        const excludeModules = modules
          .filter((module) => {
            return !module.enabled;
          })
          .map((module) => {
            return module.id;
          });

        this.defineIamRoles(iamRoles, excludeModules);
        return iamRoles;
      });
  }

  setSitePermissions(siteId, modules) {
    const deferred = this.$q.defer();

    this.clearCurrentPermissions();
    this.sitesRequestsService.getSiteRoles(siteId)
      .then((res) => {
        this.siteContextService.setMemberPermissions(res);

        const iamRoles = res.roles;
        const excludeModules = modules
          .filter((module) => {
            return !module.enabled;
          })
          .map((module) => {
            return module.id;
          });

        this.defineIamRoles(iamRoles, excludeModules);
        deferred.resolve(iamRoles);
      })
      .catch((error) => {
        this.$log.error(error);
      })

    return deferred.promise;
  }

  hasPermission(permissionId) {
    var permissions = this.PermPermissionStore.getStore();
    return !_.isUndefined(permissions[permissionId]);
  }

  hasRole(roleName) {
    var role = this.PermRoleStore.getRoleDefinition(roleName);
    return !_.isUndefined(role);
  }

  clearCurrentPermissions() {
    this.PermPermissionStore.clearStore();
    this.PermRoleStore.clearStore();
  }

  defineIamRoles(iamRoles, excludeModules) {
    const permissions = [];
    const roles = {};

    // Parse server response
    _.forEach(iamRoles, (role) => {
      if (role) {
        roles[role.id] = [];
        _.forEach(role.permissions, (permission) => {
          const module = permission.id.split('.')[0];

          if (excludeModules.indexOf(module) === -1) {

            roles[role.id].push(permission.id);
            if (permissions.indexOf(permission.id) === -1) {
              permissions.push(permission.id);
            }

          }
        });
      }
    });

    this.PermPermissionStore.defineManyPermissions(permissions, /*@ngInject*/ (permissionName) => {
      return _.includes(permissions, permissionName);
    });

    this.PermRoleStore.defineManyRoles(roles);

    this.permissionsService.loadPermissions(permissions);
    this.ngxRolesService.addRoles(roles);
  }


}

angular
  .module('app.permission')
  .service('IAMPermissions', IAMPermissionsService);
